import {
  GeneratorSwitchButtonFalseIcon,
  GeneratorSwitchButtonTrueIcon,
  GuitarPixelIcon,
  PianoPixelIcon,
  SaxPixelIcon,
} from '@/components/Icons';
import Show from '@/components/Show';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import useGeneratorStore, { EditorInstrumentEnum, EditorTypeEnum } from '@/state/generator-store';
import React from 'react';
import CardContainer from '../../ui/CardContainer';
import PromptTextTextarea from '../../PromptTextArea/PromptTextTextarea';

interface PreviewEditorCardProps {
  // onUploaded?: (props: onUploadedProps) => void;
  // onPromiseCheckChange?: (isChecked: boolean) => void;
}

interface Instrument {
  name: string;
  icon: React.ReactNode;
  iconSelected: React.ReactNode;
  id: EditorInstrumentEnum;
}

const PreviewEditorCard: React.FC<PreviewEditorCardProps> = () => {
  const instruments = [
    {
      name: 'Acoustic Guitar',
      iconSelected: <GuitarPixelIcon fillColor="#000" className="w-8 h-8" />,
      icon: <GuitarPixelIcon fillColor="#fff" className="w-8 h-8" />,
      id: EditorInstrumentEnum.AcousticGuitar,
    },
    {
      name: 'Electric Guitar',
      iconSelected: <GuitarPixelIcon fillColor="#000" className="w-8 h-8" />,
      icon: <GuitarPixelIcon fillColor="#fff" className="w-8 h-8" />,
      id: EditorInstrumentEnum.ElectricGuitar,
    },
    // {
    //   name: 'Electric Piano',
    //   iconSelected: <PianoPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <PianoPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.ElectricPiano,
    // },
    // {
    //   name: 'Flamenco Guitar',
    //   iconSelected: <GuitarPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <GuitarPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.FlamencoGuitar,
    // },
    {
      name: 'Grand Piano',
      iconSelected: <PianoPixelIcon fillColor="#000" className="w-8 h-8" />,
      icon: <PianoPixelIcon fillColor="#fff" className="w-8 h-8" />,
      id: EditorInstrumentEnum.GrandPiano,
    },
    // {
    //   name: 'Harp',
    //   iconSelected: <PianoPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <PianoPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.Harp,
    // },
    // {
    //   name: 'Saxophone',
    //   iconSelected: <SaxPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <SaxPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.Saxophone,
    // },
    // {
    //   name: 'Steel Guitar',
    //   iconSelected: <GuitarPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <GuitarPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.SteelGuitar,
    // },
    // {
    //   name: 'Trombone',
    //   iconSelected: <SaxPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <SaxPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.Trombone,
    // },
    // {
    //   name: 'Trumpet',
    //   iconSelected: <SaxPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <SaxPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.Trumpet,
    // },
    // {
    //   name: 'Violin',
    //   iconSelected: <PianoPixelIcon fillColor="#000" className="w-8 h-8" />,
    //   icon: <PianoPixelIcon fillColor="#fff" className="w-8 h-8" />,
    //   id: EditorInstrumentEnum.Violin,
    // },
  ];

  const { editorType, setEditorType, editorSelectedInstrument, setEditorSelectedInstrument } = useGeneratorStore();

  return (
    <CardContainer>
      <Card className="w-full border-none">
        <div className="bg-gradient-to-br from-[#383a3c] to-[#2b2e2f] ">
          <CardHeader className="p-1">
            <div className="flex items-center w-full">
              <div className="m-1 mb-2 bg-gradient-to-t from-[#181a1b] to-[#1e1f21] rounded-full shadow-inner border border-white">
                <div
                  className="py-1 px-3 bg-gradient-to-br from-[#2b2d2f] to-[#1b1d1e] rounded-full border border-white cursor-pointer flex justify-center items-center"
                  onClick={() => {
                    setEditorType(EditorTypeEnum.instrument);
                  }}
                >
                  <Show when={editorType === 'instrument'}>
                    <GeneratorSwitchButtonTrueIcon />
                  </Show>
                  <Show when={editorType === 'text'}>
                    <GeneratorSwitchButtonFalseIcon />
                  </Show>
                  <div className="text-[0.8rem] font-pressura-mono text-white ml-1">INSTRUMENTS</div>
                </div>
              </div>
              <div className="m-1 mb-2 bg-gradient-to-t from-[#181a1b] to-[#1e1f21] rounded-full shadow-inner border border-white">
                <div
                  className="py-1 px-3 bg-gradient-to-br from-[#2b2d2f] to-[#1b1d1e] rounded-full border border-white cursor-pointer flex justify-center items-center"
                  onClick={() => {
                    setEditorType(EditorTypeEnum.text);
                  }}
                >
                  <Show when={editorType === 'text'}>
                    <GeneratorSwitchButtonTrueIcon />
                  </Show>
                  <Show when={editorType === 'instrument'}>
                    <GeneratorSwitchButtonFalseIcon />
                  </Show>
                  <div className="text-[0.8rem] font-pressura-mono text-white ml-1">TEXT</div>
                </div>
              </div>
            </div>
          </CardHeader>
          <CardContent className="flex flex-col items-center rounded-md p-1 bg-gradient-to-t from-[#2d3032] to-[#292a2b] h-60 overflow-y-auto">
            <ScrollArea className="max-h-[20rem] w-full">
              <Show when={editorType === 'instrument'}>
                {instruments
                  .reduce((rows: any, instrument: Instrument, index: number) => {
                    if (index % 2 === 0) {
                      rows.push([instrument]);
                    } else {
                      rows[rows.length - 1].push(instrument);
                    }
                    return rows;
                  }, [])
                  .map((row: Instrument[], rowIndex: number) => (
                    <div key={rowIndex} className="flex justify-between items-center w-full">
                      {row.map((instrument: Instrument) => (
                        <Button
                          key={instrument.id}
                          type="button"
                          className={`flex justify-start w-1/2 items-center rounded-sm m-1 ${editorSelectedInstrument === instrument.id ? 'bg-white text-black' : 'bg-[#111112] hover:bg-[#262627] transition-all duration-200'}`}
                          onClick={() => {
                            setEditorSelectedInstrument(instrument.id);
                          }}
                        >
                          <span>{editorSelectedInstrument === instrument.id ? instrument.iconSelected : instrument.icon}</span>
                          <span
                            className="text-[1rem] ml-1.5"
                            style={{
                              color: editorSelectedInstrument === instrument.id ? 'black' : 'white',
                            }}
                          >
                            {instrument.name}
                          </span>
                        </Button>
                      ))}
                    </div>
                  ))}
              </Show>
              <Show when={editorType === 'text'}>
                <PromptTextTextarea />
              </Show>
            </ScrollArea>
          </CardContent>
        </div>
      </Card>
    </CardContainer>
  );
};

export default PreviewEditorCard;
